import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Snackbar from '../components/Snackbar'
import NotificationActions from '../redux/notificationRedux'

class SnackbarContainer extends PureComponent {
  render () {
    const { notification, actions } = this.props
    return (
      <Snackbar notification={notification} handleClose={actions.notificationRemoved} />
    )
  }
}

const mapStateToProps = state => {
  return {
    notification: state.notification.notifications[0]
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      notificationRemoved: () => dispatch(NotificationActions.notificationRemoved())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SnackbarContainer)



// WEBPACK FOOTER //
// ./src/containers/NotificationsContainer.js